<template>
  <v-card class="main-content-card" id="inte-intellectualCheck-card">
    <v-toolbar flat>
      <v-toolbar-title>知识产权审核</v-toolbar-title>
    </v-toolbar>

    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field
                label="知识产权名称"
                v-model="form.name"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm3>
              <v-autocomplete
                item-text="name"
                item-value="dbid"
                :items="typeItems"
                v-model="form.typeId"
                label="知识产权类型"
                hide-details
                clearable
                :menu-props="{maxHeight:600}"
              />
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field
                label="参与人"
                v-model="form.app"
                :clearable="true"
                hide-details
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-menu
                      ref="refApplDateStart"
                      :close-on-content-click="false"
                      v-model="menuApplDateStart"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
              >
                <v-text-field
                        slot="activator"
                        v-model="form.applDateStart"
                        label="提交日期（起始）"
                        clearable
                        :rules="rules.applDateStart"
                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                        persistent-hint
                />
                <v-date-picker
                        v-model="applDateStart"
                        locale="zh-cn"
                        @change="nv => form.applDateStart= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4>
              <v-menu
                      ref="refApplDateEnd"
                      :close-on-content-click="false"
                      v-model="menuApplDateEnd"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
              >
                <v-text-field
                        slot="activator"
                        v-model="form.applDateEnd"
                        label="提交日期(截止)"
                        clearable
                        :rules="rules.applDateEnd"
                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                        persistent-hint
                />
                <v-date-picker
                        v-model="applDateEnd"
                        locale="zh-cn"
                        @change="nv => form.applDateEnd= nv"
                />
              </v-menu>
            </v-flex>
            <v-flex xs12 sm4>
              <v-autocomplete
                item-text="name"
                item-value="dbid"
                :items="deptItems"
                v-model="form.deptId"
                label="归属部门"
                hide-details
                clearable
                :menu-props="{maxHeight:600}"
              />
            </v-flex>

            <v-flex xs12>
              <span>审核状态：</span>
              <v-btn-toggle
                v-model="form.statusId"
                class="transparent"
                style="background:none;box-shadow:none"
              >
                <v-btn value="" flat>全部</v-btn>
                <v-btn flat v-for="s in statusItems" :key="s.dbid" :value="s.identifier">{{s.name}}</v-btn>
              </v-btn-toggle>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>

    <v-data-table
      :headers="headers"
      :loading="loading"
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{props.item.name }}<br>{{props.item.type.name }}</td>
        <td> {{ (props.item.persons || []).map( v => `${v.name}(${v.order})` ).join(', ') }}<br>{{props.item.department.name}}</td>
        <td>{{props.item.submitDate}}</td>
        <td>
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
        </td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { $router.push(`/inte/inteAppManage/${props.item.dbid}`) }">
              <v-icon color="teal">toc</v-icon>
            </v-btn>
            <span>管理/查看</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <x-history
      v-model="hist"
      :history="history"
      :status="statusItems"
    />
  </v-card>
</template>

<script>

  import mixin from '@/mixin'

  import XHistory from '@/components/global/History'
  const  baseUri= '/api/inte/intellectualApp'
  const statusUri = '/api/code/status';
  const deptUri = '/api/syst/department';
  const inteTypeUri = '/api/inte/intellectualType'

  export default {
    // 混入模块列表页面（index）基本功能
    mixins: [mixin.index(baseUri)],
    components: {XHistory},

    data() {
      return {
        uri: baseUri,
        fileUri: '/api/inte/file',
        searchName: '',
        loading: false,
        total: 0,
        items: [],

        // 检索、分页、排序条件条件
        query: {
          statusId: '',
          name: '',
          typeId: '',
          app: '',
          applDateStart: '',
          applDateEnd: '',
          departmentId: '',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },
        // 检索框
        form: {
          statusId: '',
          name: '',
          typeId: '',
          app: '',
          applDateStart: '',
          applDateEnd: '',
          departmentId: '',
        },

        statusItems: [],
        typeItems: [],
        deptItems: [],

        menuApplDateStart: false,
        menuApplDateEnd: false,

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '知识产权名称/类型', align: 'left', sortable: true, value: 'name'},
      //    {text: '知识产权类型', align: 'left', sortable: true, value: 'typeId'},
      //    {text: '知识产权归属部门', align: 'left', sortable: true, value: 'department'},
          {text: '参与人/知识产权归属部门', align: 'left', sortable: true, value: 'persons'},
          {text: '提交日期', align: 'left', sortable: true, value: 'submitDate'},
          {text: '审核状态', align: 'left', sortable: true, value: 'status'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],

        view: false,
        viewDbid: null,

        hist: false,
        history: [],

        edit: false,
        editDbid: null,
          rules: {
              applDateStart: [
                  v => !!v || "必填项。",
                  v => window.xutil.regexpDate().test(v) || '日期格式错误'
              ],
              applDateEnd: [
                  v => !!v || "必填项。",
                  v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                  v => (v && v >= this.form.applDateStart) || "截止日期必须晚于或等于起始日期。"
              ]
          }
      }
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
        this.axios.get(inteTypeUri, {params: {sort: 'order.asc'}}),
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          (rspStaus,rspType, rspDept) => {
            this.statusItems = rspStaus.data.items;
            this.typeItems =rspType.data.items;
            this.deptItems = rspDept.data.items;
          }
        )
      )
    },

    methods: {
      // 检索响应函数
      onSearch() {
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.doRoute(this.query);
      }
    }
  }
</script>
